import React, { useState,useEffect,useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow,
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import axios from 'axios';

export default function GlobalLowStockAlert() {
const CHECK_INTERVAL =  60 * 60 * 1000; // 1 hour

const alertAudio = useRef(new Audio("/notification_tone.mp3"));

const [openAlert, setOpenAlert] = useState(false);
const [lowStockCount, setLowStockCount] = useState(0);
const [showList, setShowList] = useState(false);
const [medicines, setMedicines] = useState([]);
const navigate = useNavigate();

 useEffect(() => {
    checkLowStock();
    const interval = setInterval(checkLowStock, CHECK_INTERVAL);

    return () => clearInterval(interval);
  }, []);
const checkLowStock = async () => {
  try {

          const response = await axios.get(`${process.env.REACT_APP_API}/purchase-orders/suggestions/low-stock`);

          console.log(response.data.suggestions)

     if (response.data.total > 0) {
        setMedicines(response.data.suggestions || []);
        //   setSuggestions(response.data.suggestions || []);

        //   setSummary(response.data.summary || null);

        console.log("kkkk")

        setLowStockCount(response.data.total);
        alertAudio.current.play().catch(() => {});
        setOpenAlert(true);
        

      }

    } catch (err) {

      console.error(err);

    
  }
};
  return (
<Dialog
  open={openAlert}
  maxWidth="sm"
  fullWidth
  disableEscapeKeyDown
  PaperProps={{
    sx: {
      borderRadius: "20px",
      padding: "10px",
      animation: showList ? 'none':"pulse 1.2s infinite",
      "@keyframes pulse": {
        "0%": {
          transform: "scale(1)",
          boxShadow: "0 0 0 0 rgba(255, 152, 0, 0.7)",
        },
        "70%": {
          transform: "scale(1.03)",
          boxShadow: "0 0 0 20px rgba(255, 152, 0, 0)",
        },
        "100%": {
          transform: "scale(1)",
          boxShadow: "0 0 0 0 rgba(255, 152, 0, 0)",
        },
      },
    },
  }}
>
  <DialogTitle
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: 1,
      backgroundColor: "#FFF3CD",
      color: "#856404",
      fontWeight: "bold",
      fontSize: "30px",
      padding: "20px",
    }}
  >
    <WarningAmberIcon sx={{ color: "#FF9800", fontSize: 45 }} />
    LOW STOCK ALERT
  </DialogTitle>

  <DialogContent
    sx={{
      textAlign: "center",
      padding: "30px",
    }}
  >
   {!showList ? ( <div><Typography
      sx={{
        fontSize: "26px",
        fontWeight: 700,
        color: "#D32F2F",
      }}
    >
      {lowStockCount} medicine{lowStockCount > 1 ? "s are" : " is"} running low on stock.
    </Typography>

    <Typography
      sx={{
        marginTop: "15px",
        fontSize: "18px",
        color: "#555",
      }}
    >
      Please restock these medicines immediately.
    </Typography></div>)
    : (

        <Table size="small">

            <TableHead>
                <TableRow>
                    <TableCell sx={{ fontWeight: 700, fontSize: "16px" }}>Medicine</TableCell>
                    <TableCell align="center" sx={{ fontWeight: 700, fontSize: "16px" }}>Stock</TableCell>
                    <TableCell align="center" sx={{ fontWeight: 700, fontSize: "16px" }}>Action</TableCell>
                </TableRow>
            </TableHead>

            <TableBody>

                {medicines.map((medicine) => (

                    <TableRow key={medicine.medicine_id}>

                        <TableCell>
                            {medicine.medicine_name}
                        </TableCell>

                        <TableCell align="center">
                            {medicine.current_stock}
                        </TableCell>

                        <TableCell align="center">

                            <Button
                                variant="contained"
                                size="small"
                                // onClick={() =>{
                                //     navigate("/diagnostic-masterdata", {
                                //         state: {
                                //             medicineId: medicine.medicine_id,
                                //             editStock: true,
                                //             lowStockTab:"medicine"
                                //         },
                                //     });
                                // setOpenAlert(false);
                                // }
                                // }
                                 onClick={() =>{
                                    navigate("/purchase-orders");
                                setOpenAlert(false);
                                }
                                }
                            >
                                Add Stock
                            </Button>

                        </TableCell>

                    </TableRow>

                ))}

            </TableBody>

        </Table>

    )}
  </DialogContent>
  

  <DialogActions
    sx={{
      justifyContent: "center",
      gap: 2,
      paddingBottom: "25px",
    }}
  >
   {!showList &&( <Button
      variant="contained"
      color="warning"
      sx={{
        borderRadius: "10px",
        px: 4,
        py: 1.2,
        fontWeight: "bold",
      }}
      onClick={() => {
        alertAudio.current.pause();
        alertAudio.current.currentTime = 0;
         setShowList(true)
      }}
    >
      View Medicines
    </Button>)}

    <Button
      variant="outlined"
      color="error"
      sx={{
        borderRadius: "10px",
        px: 4,
        py: 1.2,
        fontWeight: "bold",
      }}
      onClick={() => {
        alertAudio.current.pause();
        alertAudio.current.currentTime = 0;
        setOpenAlert(false);
      }}
    >
      Dismiss
    </Button>
  </DialogActions>
  
</Dialog>

  )
}